__turbopack_context__.v({
  "showLegend": "xuukFW_showLegend",
});
